import FilterWrapper from "Components/FilterWrapper/FilterWrapper";
import DateRange from "Components/UI/DateRange/DateRange";
import SearchFilters from "Components/UI/ModalFilters/SearchFiters/SearchFiters";
import QuarterRange from "Components/UI/QuarterRange/QuarterRange";
import styles from "./FilterPanel.module.scss";
import React, { FC } from "react";
import IconButton from "Components/UI/IconButton/IconButton";
import { PlusIcon } from "Assets";
import { useWorkOrderListHook } from "Containers/WorkOrders/WorkOrderList/useWorkOrderHook";
export const FilterPanel: FC = () => {
  const { goToWorkOrderAdd } = useWorkOrderListHook();
  return (
    <section className={styles.wrapper}>
      <FilterWrapper>
        <SearchFilters key={"searchFiltersWorkOrderDND"} />
        <DateRange
          rangeStartName="work_order_from"
          rangeEndName="work_order_to"
        />
        <QuarterRange
          fromParamName="work_order_from"
          toParamName="work_order_to"
        />
      </FilterWrapper>
      <IconButton
        onClick={goToWorkOrderAdd}
        icon={PlusIcon}
        label="Add Work Order"
        isAlwaysOpen
        width={18}
        height={18}
      />
    </section>
  );
};
